import { render, staticRenderFns } from "./ServicesOverview.vue?vue&type=template&id=4d8833b4&scoped=true&"
import script from "./ServicesOverview.vue?vue&type=script&lang=js&"
export * from "./ServicesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ServicesOverview.vue?vue&type=style&index=0&id=4d8833b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8833b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8833b4')) {
      api.createRecord('4d8833b4', component.options)
    } else {
      api.reload('4d8833b4', component.options)
    }
    module.hot.accept("./ServicesOverview.vue?vue&type=template&id=4d8833b4&scoped=true&", function () {
      api.rerender('4d8833b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Services/ServicesOverview.vue"
export default component.exports